/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-shadow */

'use client';

import React, { memo, useMemo, useState, useEffect, useCallback } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';

import { TabPanel } from './TabPanel';
import { TabsWrap } from './TabsStyles';

interface IProps {
  id?: string;
  children?: React.ReactNode;
  selectedValue?: string;
  className?: string;
  refs?: any;
  onChange?: (value: string, index: number) => void;
}

const Tabs = ({
  refs,
  id,
  className,
  selectedValue,
  children,
  onChange,
}: IProps) => {
  const [$selectedValue, setSelectedValue] = useState(selectedValue);

  useEffect(() => {
    setSelectedValue(selectedValue);
    // console.log("useEffect Tabs ==> ", selectedValue);
  }, [selectedValue]);

  const param = {
    id: id || undefined,
    role: 'tablist',
    className: useMemo(
      () => classNameBind(['tabs', className || '']),
      [className]
    ),
  };

  // EVENT HANDLER : onClickTab
  const onClickTab = useCallback(
    (e: any, index: number) => {
      const v = e.target.getAttribute('aria-controls');

      if ($selectedValue !== v) {
        // setSelectedValue(v)
        if (typeof onChange === 'function') onChange(v, index);
      }
    },
    [$selectedValue, onChange]
  );

  // ITEM RENDERER : getLabel
  const getLabel = useCallback(
    (children: React.ReactNode) => {
      if (children instanceof Array) {
        return children?.map((v: React.ReactElement, i: number) => {
          const { value, label, className } = v.props as {
            value: string;
            label: string;
            className: string;
          };
          return (
            <Button
              key={i}
              className={classNameBind(['tabs-tab', className || ''])}
              onClick={e => onClickTab(e, i)}
              role="tab"
              ariaControls={value}
              ariaSelected={value === $selectedValue}
            >
              {label}
            </Button>
          );
        });
      }
    },
    [onClickTab, $selectedValue]
  );

  // ITEM RENDERER : getCont
  const getCont = useCallback(
    (children: React.ReactNode) => {
      if (children instanceof Array) {
        return children?.map((v: React.ReactElement<any>, i: number) => {
          const { value, children } = v.props as {
            value: string;
            children: React.ReactNode;
          };
          return (
            <TabPanel
              key={i}
              id={value}
              className="tabs-panel"
              ariaHidden={value !== $selectedValue}
              styles={{ height: '100%' }}
            >
              {children}
            </TabPanel>
          );
        });
      }
    },
    [$selectedValue]
  );

  return (
    <TabsWrap ref={refs} {...param}>
      <div className="tabs-label">{getLabel(children)}</div>
      <div className="tabs-cont">{getCont(children)}</div>
    </TabsWrap>
  );
};

export default memo(Tabs);
